import Persisted_Progress, {JackpotValues} from "integration/revolver/schema/persisted-progress";
import Layers from "slotworks/graphics/layers/layers";
import currency from "slotworks/i18n/currency";
import betModel from "slotworks/model/bets/bet-model";
import Components from "slotworks/components/components";
import deviceInfo from "slotworks/utils/device-info";

export default class JackpotMeterComponent {

    private MULTIPLIERS: JackpotValues = { GRAND: 750, MAJOR: 200, MAXI: 75, MINI: 25}

    private CONTRIBUTIONS: JackpotValues = { GRAND: 0, MAJOR: 0, MAXI: 0, MINI: 0}

    private values: Map<number, JackpotValues> = new Map();

    private layer: Layers;

    constructor() {
        this.layer = Layers.Custom.get("JackpotMeters");
        this.layer.onSceneEnter.add(() => this.setValues());
    }

    public init() {
        Components.betBar.onBetUpdated.add(() => setTimeout(() => {
            this.setValues();
            this.populatePaytable();
        }, 100));
        Components.betMenu.onBetOptionsCommitted.add(() => setTimeout(() => {
            this.setValues();
            this.populatePaytable();
        }, 100));
        
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(() => {
                setTimeout(() => {
                    this.setValues();
                }, 10);
            });
        }
    }

    public setMode(mode: JackpotMeterComponentMode) {
        this.layer.setScene(mode).execute();
    }
    
    public parsePersistedProgress(data: Persisted_Progress, show: boolean = true) {
        if(data?.jackpotValues) {
            this.values.clear();
            for(let bet in data.jackpotValues) {
                const key:number = parseInt(bet, 10);
                const jackpotValues = data.jackpotValues[bet];
                this.values.set(key, jackpotValues);
            }
        } 
        if(data?.jackpotIncValues) {
            for(let k in data.jackpotIncValues) {
                const key = k as keyof JackpotValues;
                this.CONTRIBUTIONS[key] = +data.jackpotIncValues[key];
            }
        }
        this.setValues();
    }

    public getJackpotByType(type: string) {
        const key: string = type.toUpperCase();
        return this.getCurrent(betModel.getTotalBet())[key as keyof JackpotValues];
    }

    public populatePaytable() {
        const current = this.getCurrent(betModel.getTotalBet());
        for(let key in current) {
            const paytableText = Layers.PaytableContent.getFlexiText(key + "_value");
            if(paytableText) {
                paytableText.setText(currency.format(current[key as keyof JackpotValues]));
            }
        }
    }

    public update() {
        this.setValues();
    }

    private getDefaultValuesForBet(bet: number) {
        return { 
            GRAND: this.MULTIPLIERS.GRAND * bet + this.CONTRIBUTIONS.GRAND, 
            MAJOR: this.MULTIPLIERS.MAJOR * bet + this.CONTRIBUTIONS.MAJOR, 
            MAXI: this.MULTIPLIERS.MAXI * bet + this.CONTRIBUTIONS.MAXI, 
            MINI: this.MULTIPLIERS.MINI * bet + this.CONTRIBUTIONS.MINI
        };
    }

    private getCurrent(bet: number) {
        if(this.values.has(bet)) {
            return this.values.get(bet);
        }
        return this.getDefaultValuesForBet(bet);
    }

    private setValues() {
        const current = this.getCurrent(betModel.getTotalBet());
        for(let key in current) {
            const textField = this.layer.getText(key);
            if(textField) {
                textField.text = currency.format(current[key as keyof JackpotValues]);
            }
        }
    }

}

export enum JackpotMeterComponentMode {
    DEFAULT = "default",
    FREESPINS = "freespins"
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/jackpot/jackpot-meter-component.ts